import React from "react";
import TextField from "@mui/material/TextField";

const CustomTextField = (props) => {
  return <TextField {...props} />;
};

export default CustomTextField;
